import(/* webpackMode: "eager" */ "/usr/src/next-app/src/app/global-error.tsx");
